// @flow
import * as React from 'react';
import FilePlayer from 'react-player/file';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { environment } from '../../../../../../environments/environment';
import { getToken } from '@coverright/shared/keycloak';
import { Collapse, LinearProgress } from '@mui/material';

export const CallPlayer = forwardRef(({id}: {id?: string}, ref) => {
  const player = useRef<FilePlayer>(null);
  const [playing, setPlaying] = useState(false);
  const [link, setLink] = useState('');
  const [showLoading, setShowLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    seekTo: (amount: number) => {
      player.current?.seekTo(amount);
      setPlaying(true);
    },
  }));

  useEffect(() => {
    if (id && !link) {
      setShowLoading(true);
      getToken().then(token => (
        fetch(environment.aircallUrl + '/' + id, {
          method: 'GET',
          headers: {
            authorization: 'Bearer ' + token
          },
        })
      )).then(response => response.blob())
        .then(blob => {
          setLink(window.URL.createObjectURL(new Blob([blob], { type: 'audio/mpeg' })))
        })
        .finally(() => setShowLoading(false))
    }
  }, [id, link]);

  if (!id) return null;

  return (<div>
    {showLoading && <LinearProgress color={'success'} />}
    <Collapse in={!!link}>
      {link && <FilePlayer height={50} width={'100%'} ref={player} config={{forceAudio: true}} controls url={link} playing={playing} />}
    </Collapse>
  </div>);
});
